import { Button } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './CourseSelector.scss';

/**
 * CourseSelector - Allows switching between multiple courses
 */
const CourseSelector = ({ courses, selected, onChange }) => {
  const { t } = useTranslation(['chatbot']);

  if (!courses || courses.length <= 1) {
    return null;
  }

  return (
    <div className="course-selector">
      {courses.map((course) => (
        <Button
          key={course.guid}
          text={course.education_discipline_name || course.name}
          variant={selected === course.guid ? 'primary' : 'neutral-outline'}
          size="sm"
          onClick={() => onChange(course.guid)}
          className="course-selector__button"
          isFullWidth
        />
      ))}
    </div>
  );
};

CourseSelector.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      guid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      education_discipline_name: PropTypes.string,
    })
  ).isRequired,
  selected: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default CourseSelector;
